<mat-dialog-content>
  <div class="flex flex-col">
    <div class="flex w-full justify-end">
      <mat-icon class="cursor-pointer" [mat-dialog-close]="false"
        >close</mat-icon
      >
    </div>

    <div class="flex w-full">
      <div class="mt-2 flex h-12 w-12 items-center justify-center">
        <span class="material-symbols-outlined rounded-sm text-rose-500">
          warning
        </span>
      </div>
      <div class="flex flex-1 flex-col">
        <div mat-dialog-title>{{ data.title }}</div>
        <span class="ml-6">{{ data.message }}</span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <div class="flex flex-row items-center justify-between gap-8 pb-4">
    <div class="col-auto">
      <button
        mat-button
        color="primary"
        class="!px-8 !py-6 !text-base !font-normal !tracking-normal"
        mat-dialog-close
        type="button">
        @if (data.cancelIcon) {
          <mat-icon>
            {{ data.cancelIcon }}
          </mat-icon>
        }
        {{ data.cancelText || 'Cancelar' }}
      </button>
    </div>
    <div class="col-auto">
      <button
        mat-flat-button
        class="!px-14"
        color="primary"
        type="button"
        [mat-dialog-close]="true"
        cdkFocusInitial>
        {{ data.confirmText }}
      </button>
    </div>
  </div>
</mat-dialog-actions>
